import React, { useEffect, useState } from "react";
import { auth } from "../data/fire";
import { Link } from "react-router-dom";
import logosidebar from "../../src/images/logosidebar.png";
import Configuracion from "../data/configuracion";
import apibig from "../components/Apibig";
import DynamicIcon from "./DynamicIcon";

const SidebarItemComponent = ({ item, expanded, clavep }) => {
  const [open, setOpen] = useState(false);

  if (item.menus?.length > 0) {
    return (
      <div className={`w-full`}>
        <div
          onClick={() => setOpen(!open)}
          className={`cursor-pointer ${expanded ? "w-[16rem]" : ""} flex justify-between
           items-center gap-2 
          hover:bg-sidebarhover-100 hover:text-textosidebar-200 rounded mx-2 mt-2`}
        >
          <DynamicIcon
            iconName={item.Icono}
            size={`${expanded ? "1.5rem" : "1rem"}`}
          />
          {expanded && (
            <span className={`${expanded ? "w-[16rem] pl-2" : "hidden"}`}>
              {item.Titulo}
            </span>
          )}
          {expanded && (
            <DynamicIcon
              iconName="chevronright"
              size={`${expanded ? "1.5rem" : "1rem"} pr-[4rem]`}
            />
          )}
        </div>
        <div className={`${open ? "block" : "hidden"} pl-4`}>
          {item.menus.map((child, index) => (
            <SidebarItemComponent
              key={index}
              item={child}
              expanded={expanded}
              clavep={child.Clavep}
            />
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <Link
        to={item.Win ? item.URL : item.Ruta}
        target={item.Win ? "_blank" : undefined}
        className="w-full"
      >
        <div
          className={`cursor-pointer ${expanded ? "w-[16rem]" : ""} flex justify-between items-center gap-4 py-2 hover:bg-sidebarhover-100 hover:text-textosidebar-200 rounded mx-2`}
        >
          <DynamicIcon
            iconName={item.Icono}
            size={`${expanded ? "1.5rem" : "1rem"}`}
          />
          {expanded && <span className="w-[16rem] ">{item.Titulo}</span>}
        </div>
      </Link>
    );
  }
};

const Sidebar = ({ autusuario, permisos }) => {
  const [expanded, setExpanded] = useState(true);
  const [datapermisos, setDatapermisos] = useState(permisos.permisos || []);
  const usrimg = autusuario.photoURL;
  const usuario = autusuario.displayName;
  const email = autusuario.email;

  useEffect(() => {
    const fetchroles = async () => {
      try {
        const proyecto = Configuracion.proyecto;
        const basedatos = Configuracion.basedatos;
        const response = await apibig.post("/api/permisos/getpermisosxusuario", {
          appid: proyecto,
          email: email,
          basedatos: basedatos,
        });
        const data = response.data;
        sessionStorage.setItem("data", JSON.stringify(data));
        setDatapermisos(data.permisos || []);
      } catch (error) {
        console.error("Error al obtener permisos:", error);
      }
    };

    fetchroles();
  }, []);

  function handleClose() {
    auth.signOut();
  }

  return (
    <div
      className={`h-screen flex flex-col justify-between bg-sidebar-100 text-textosidebar-100  
      ${expanded ? "w-[20rem]" : "w-[2rem]"} z-50`}
    >
      {/* Top */}
      <div>
        <div
          className={`flex items-center ${
            expanded ? "justify-around " : "justify-center"
          } h-[3rem] mb-4`}
        >
          {expanded && <img className="h-[1.5rem]" src={logosidebar} alt="Logo" />}
          <div
            onClick={() => setExpanded(!expanded)}
            className="cursor-pointer"
          >
            <DynamicIcon
              iconName="menu"
              size={`${expanded ? "1.5rem" : "1rem"}`}
            />
          </div>
        </div>

        <div className="flex flex-col items-center pb-4">
          <img
            className={`${expanded ? "w-[4rem]" : "w-[1rem]"} rounded-full`}
            src={usrimg}
            alt="User"
          />
          {expanded && (
            <>
              <span className="text-xs mt-2">{usuario}</span>
              <span className="text-xs">{email}</span>
            </>
          )}
        </div>
      </div>

      {/* Middle - Menu Items con Scroll solo si está expandido */}
      <div className={`flex-1 ${expanded ? "overflow-y-auto" : "overflow-hidden"}`}>
        <Link to="/">
          <div
            className="flex items-center gap-4 hover:bg-sidebarhover-100 hover:text-textosidebar-200 
          rounded mx-2 mt-2"
          >
            <DynamicIcon
              iconName="home"
              size={`${expanded ? "1.5rem" : "1rem"}`}
            />
            {expanded && <span>Inicio</span>}
          </div>
        </Link>
        <div className="flex-1">
          {datapermisos.map((item, index) => (
            <SidebarItemComponent
              key={index}
              item={item}
              expanded={expanded}
              clavep={item.Clavep}
            />
          ))}
        </div>

        <div
          onClick={handleClose}
          className="cursor-pointer flex items-center gap-4 hover:bg-sidebarhover-100 
          hover:text-textosidebar-200 rounded mx-2 mt-2"
        >
          <DynamicIcon
            iconName="salir"
            size={`${expanded ? "1.5rem" : "1rem"}`}
          />
          {expanded && <span>Salir</span>}
        </div>
      </div>

      {/* Footer Spacer */}
      <div className="h-10" />
    </div>
  );
};

export default Sidebar;
